import { updateLocale } from '@americanexpress/one-app-ducks';
import setAXPLocaleCookie from './setAXPLocaleCookie';

/**
 * country code to locale mapper
 */
const localeMapper = {
  en: 'en-US',
  us: 'en-US',
  jp: 'ja-JP',
  ja: 'ja-JP',
  au: 'en-AU',
  uk: 'en-GB',
  ca: 'en-CA',
};

export const getLocaleFromLocation = (pathname) => String(pathname).split('/').filter(Boolean)[0] || null;

export const normalizeLocale = (locale) => {
  const [lang, country] = String(locale).split('-');
  return `${lang.toLowerCase()}-${country.toUpperCase()}`;
};

const setActiveLocale = (store) => (nextState) => {
  const { dispatch, getState } = store;
  const state = getState();
  const activeLocale = state.getIn(['intl', 'activeLocale']);
  const localeFromLocationURL = getLocaleFromLocation(nextState.location.pathname);

  // locale mapper allow for partial matches such as 'en' to 'en-US', and 'uk' to 'en-GB'
  const mappedLocale = localeMapper[localeFromLocationURL] || localeFromLocationURL;
  const isValidLocale = /^[A-Za-z]{2}-[A-Za-z]{2}$/.test(mappedLocale);
  const nextLocale = isValidLocale && normalizeLocale(mappedLocale);

  setAXPLocaleCookie(nextLocale);

  if (!nextLocale || activeLocale === nextLocale) {
    return null;
  }
  return dispatch(updateLocale(nextLocale));
};

export default setActiveLocale;
